<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/Text/pre2">Acknowledgments</a></div>
<div class="SOM_part"><a href="#/Text/p1">Section One: The Three Stones</a></div>
<div class="SOM_chap"><a href="#/Text/p1chap1"><b>1</b> The Crisis We Face</a></div>
<div class="SOM_chap"><a href="#/Text/p1chap2"><b>2</b> Unchecked Baggage</a></div>
<div class="SOM_chap"><span href="#/Text/p1chap3" title="Link target outside of Sample"><b>3</b> The First Stone: A Theology of Companionship</span></div>
<div class="SOM_chap_autre"><span href="#/Text/p1chap4" title="Link target outside of Sample"><b>Tool 1:</b> <i>What’s in a Picture? Guidelines for Representing Others Through Photography</i></span></div>
<div class="SOM_chap"><span href="#/Text/p1chap5" title="Link target outside of Sample"><b>4</b> The Second Stone: An Invitation to Cultural Humility</span></div>
<div class="SOM_chap_autre"><span href="#/Text/p1chap6" title="Link target outside of Sample"><b>TOOL 2:</b> <i>Seeing into Our Blind Spots: Anticipating and Addressing Cultural Differences</i></span></div>
<div class="SOM_chap"><span href="#/Text/p1chap7" title="Link target outside of Sample"><b>5</b> The Third Stone: The Power of Co-development</span></div>
<div class="SOM_chap_autre"><span href="#/Text/p1chap8" title="Link target outside of Sample"><b>TOOL 3:</b> <i>Co-development Evaluation Tool: A Self-Check to Help Leaders Evaluate the Implications of Their Actions in Development Projects</i></span></div>
<div class="SOM_part"><span href="#/Text/p2" title="Link target outside of Sample">Section Two: Using the Three Stones</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap1" title="Link target outside of Sample"><b>6</b> Redeeming Short-Term Mission</span></div>
<div class="SOM_chap_autre"><span href="#/Text/p2chap2" title="Link target outside of Sample"><b>Tool 4:</b> <i>Preparing for the Journey: Short-Term Mission Orientation Curriculum</i></span></div>
<div class="SOM_chap_autre"><span href="#/Text/p2chap3" title="Link target outside of Sample"><b>Tool 5:</b> <i>Short-Term Mission Daily Reflection Guide</i></span></div>
<div class="SOM_chap"><span href="#/Text/p2chap4" title="Link target outside of Sample"><b>7</b> Caring for Vulnerable Children and Families</span></div>
<div class="SOM_chap"><span href="#/Text/p2chap5" title="Link target outside of Sample"><b>8</b> Unbinding Mission Leadership</span></div>
<div class="SOM_chap_autre"><span href="#/Text/p2chap6" title="Link target outside of Sample"><b>Tool 6:</b> <i>Checklist for Healthy Parish Twinning Relationships</i></span></div>
<div class="SOM_chap_autre"><span href="#/Text/p2chap7" title="Link target outside of Sample"><b>Tool 7:</b> <i>Aligning Hearts and Hands: Connecting Mission Funding Allocations to Congregational Values</i></span></div>
<div class="SOM_appen"><span href="#/Text/appen3" title="Link target outside of Sample">General Index</span></div>
<div class="SOM_appen"><span href="#/Text/appen4" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/Text/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/Text/appen6" title="Link target outside of Sample">Praise for <i>Freeing Congregational Mission</i></span></div>
<div class="SOM_appen"><span href="#/Text/appen7" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_pdf"><span href="#/Text/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?35836dce